import { NavBar, type NavItem, type NavBarProps } from './NavBar';

export type { NavItem };

export interface AppShellProps extends NavBarProps {
  children: React.ReactNode;
}

export function AppShell({ roleLabel, items, exitTo, children }: AppShellProps) {
  return (
    <>
      <NavBar roleLabel={roleLabel} items={items} exitTo={exitTo} />
      <div className="mt-14">
        <div className="flex justify-center">
          <div className="relative w-full h-screen max-w-[1024px]">{children}</div>
        </div>
      </div>
    </>
  );
}
